import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { getStrapiMedia } from '../../lib/strapi';

const NAV_LINKS_FALLBACK = [
  { id: 1, label: 'Home', url: '/' },
  { id: 2, label: 'Our Technology', url: '/our-technology' },
  { id: 3, label: 'For Farmers', url: '/for-farmers' },
  { id: 4, label: 'For Buyers', url: '/for-buyers' },
  { id: 5, label: 'Our Journey', url: '/our-journey' },
  { id: 6, label: 'Contact', url: '/contact' },
];

const Navbar = ({ global }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const rawLinks = global?.navigation_menu || global?.nav_links || NAV_LINKS_FALLBACK;
  const links = rawLinks.filter(link => !link.label?.toLowerCase().includes('sample'));
  const logoUrl = getStrapiMedia(global?.site_logo) || getStrapiMedia(global?.navbar_logo);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  return (
    <nav
      className={`sticky top-0 z-50 bg-white transition-shadow duration-300 ${
        scrolled ? 'shadow-md' : 'shadow-sm'
      }`}
    >
      <div className="w-full px-6 xl:px-10 py-4 flex justify-between items-center">
        <Link to="/" className="flex items-center">
          {logoUrl && (
            <img src={logoUrl} alt="WIDYA" className="h-10 w-auto" />
          )}
        </Link>

        <div className="hidden lg:flex items-center space-x-8">
          {links.map((link) => {
            const isActive = location.pathname === link.url;
            return (
              <Link
                key={link.id}
                to={link.url}
                className={`text-base font-bold transition-colors duration-200 ${
                  isActive
                    ? 'text-widya-green'
                    : 'text-widya-charcoal hover:text-widya-green'
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </div>

        <button
          onClick={() => setIsOpen(!isOpen)}
          className="lg:hidden text-widya-charcoal p-2 hover:text-widya-green transition-colors"
          aria-label="Toggle menu"
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {isOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 py-6 px-6 space-y-4 absolute w-full shadow-xl animate-fade-in-up">
          {links.map((link) => {
            const isActive = location.pathname === link.url;
            return (
              <Link
                key={link.id}
                to={link.url}
                onClick={() => setIsOpen(false)}
                className={`block text-base font-semibold py-2 transition-colors ${
                  isActive
                    ? 'text-widya-green'
                    : 'text-widya-charcoal hover:text-widya-green'
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </div>
      )}
    </nav>
  );
};

export default Navbar;